<template>
  <div class="conteiner text-center pt-5">
       
              <img round width="120" src="@/assets/img/logo.png" alt="" />
              <br/>
              <br/>
              <br/>

       <h1>404 :((</h1>
       <h4></a> <a href="/">Домой</a> </h4>
      
  </div>
</template>

<script>
export default {};
</script>
